var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTextActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 46,
    viewBox: "0 0 76 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "52.537%",
    y1: "100%",
    x2: "47.463%",
    y2: "0%",
    id: "yrzcyx0x8a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.44%",
    y1: "100%",
    x2: "4.56%",
    y2: "0%",
    id: "g83bfw5l7b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "88.801%",
    y1: "100%",
    x2: "11.199%",
    y2: "0%",
    id: "xzgk9ak4fc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: ".385%",
    x2: "97.491%",
    y2: "99.615%",
    id: "amv2ss48md"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACF00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3A100",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.506.05h9.81v2.237h-3.802v39.426h3.803v2.237h-9.811v-2.237h3.803V2.287h-3.803V.05z",
    fill: "url(#yrzcyx0x8a)",
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.307.05c1.157 0 2.085.254 2.825.721.796.502 1.374 1.25 1.788 2.19l11.6 26.56c.235.522.377.997.377 1.473 0 .978-.377 1.86-.997 2.496a3.358 3.358 0 0 1-2.424 1.02c-.81 0-1.49-.229-2.052-.636-.61-.443-1.078-1.095-1.42-1.887l-2.247-5.333H9.047l-2.342 5.574c-.306.717-.767 1.29-1.34 1.683-.566.388-1.243.6-1.99.6a3.264 3.264 0 0 1-2.358-.99 3.465 3.465 0 0 1-.967-2.43c0-.524.189-1.047.423-1.571l11.6-26.56c.408-.923.986-1.66 1.717-2.163.703-.483 1.548-.747 2.517-.747zm.095 8.833L11.716 20.2h9.373L16.402 8.883z",
    fill: "url(#g83bfw5l7b)",
    transform: "translate(0 6.989)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.492 8.196c3.928 0 6.77 1.053 8.57 2.877 1.893 1.92 2.742 4.753 2.742 8.208v11.76c0 .972-.384 1.836-1.007 2.46a3.462 3.462 0 0 1-2.461 1.01c-.988 0-1.815-.338-2.408-.857-.644-.563-1.012-1.34-1.012-2.13-1.838 1.885-4.252 3.18-7.752 3.18-2.485 0-4.74-.752-6.332-2.19-1.465-1.324-2.366-3.23-2.366-5.666 0-2.738.969-4.758 2.643-6.118 1.814-1.473 4.453-2.17 7.576-2.17 2.56 0 4.41.432 6.212 1.057.066-1.792-.4-3.088-1.316-3.952-.923-.87-2.304-1.302-4.135-1.302-2.003 0-3.624.29-5.008.725-.421.143-.702.19-1.03.19-.822 0-1.56-.322-2.093-.853a2.92 2.92 0 0 1-.852-2.085c0-.631.193-1.216.523-1.699.34-.495.825-.882 1.393-1.098 2.277-.866 4.745-1.347 8.113-1.347zm-.096 14.65c-1.581 0-2.853.327-3.723.966-.85.623-1.319 1.542-1.319 2.747 0 .989.399 1.776 1.085 2.32.704.56 1.714.863 2.911.863 1.693 0 3.112-.47 4.112-1.27 1.013-.812 1.596-1.963 1.596-3.31v-1.334c-1.245-.588-2.88-.982-4.662-.982z",
    fill: "url(#xzgk9ak4fc)",
    transform: "translate(0 6.989)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.587-.75a2.849 2.849 0 0 1 2.853 2.845v3.44h3.457a2.849 2.849 0 0 1 2.853 2.846 2.849 2.849 0 0 1-2.853 2.845h-3.458v3.44a2.849 2.849 0 0 1-2.853 2.845 2.849 2.849 0 0 1-2.853-2.844v-3.441h-3.457a2.849 2.849 0 0 1-2.853-2.845 2.849 2.849 0 0 1 2.853-2.845h3.457v-3.44A2.849 2.849 0 0 1 65.586-.75z",
    strokeWidth: 1.5,
    fill: "url(#amv2ss48md)",
    transform: "translate(0 2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTextActive);
export default __webpack_public_path__ + "static/media/ic_text_active.d574577bee8766f15a28cd8620b225b3.svg";
export { ForwardRef as ReactComponent };